module.exports = __webpack_public_path__ + "static/media/ModernSpace.4efebbf3.PNG";